import _asyncToGenerator from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.function.name.js";
import { computed, defineComponent } from "vue";
import { useI18n } from "vue-i18n";
import CouponIcon from "@/assets/images/svg/coupon.svg";
import { ref } from "vue";
import { getActivePromocodeCampaigns } from "@/db/promocode-campaign";
import BookingModule from "@/store/modules/booking";
import ModalModule from "@/store/modules/modal";
import { ModalStatus } from "@/constants/modal";
import { watch } from "vue";
import { removeCodePayment } from "@/utils/vue-helpers/promocode";
export default defineComponent({
  name: "promocode-campaigns",
  setup: function setup() {
    var _useI18n = useI18n({}),
        t = _useI18n.t;

    var cards = ref([]);
    var promocodeCampaigns = ref([]);
    var appliedCodes = computed(function () {
      return BookingModule.appliedPromocodes;
    });
    var isLoading = ref(false);

    function openAllCampaignsModal() {
      ModalModule.setStatus(ModalStatus.PromocodeCampaigns);
    }

    function toggleApplyPromocode(data) {
      if (data.isApplied) {
        // the promocode is already applied, let's remove it
        removeCodePayment(data.code);
        return;
      }

      ModalModule.setModalProps({
        props: data
      });
      ModalModule.setStatus(ModalStatus.PromocodeCampaignsTickets);
    }

    function loadPinnedCampaings() {
      return _loadPinnedCampaings.apply(this, arguments);
    }

    function _loadPinnedCampaings() {
      _loadPinnedCampaings = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return getActivePromocodeCampaigns({
                  pinnedOnly: true
                });

              case 2:
                promocodeCampaigns.value = _context.sent;
                updateCardsList();

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _loadPinnedCampaings.apply(this, arguments);
    }

    function updateCardsList() {
      // load only pinned campaigns
      cards.value = promocodeCampaigns.value.map(function (campaign) {
        var code = campaign.codes[0];
        var isApplied = appliedCodes.value.find(function (c) {
          return c.promocode.code === code;
        });
        return {
          id: campaign.id,
          code: code,
          name: campaign.name,
          picture: campaign.picture,
          flatValue: campaign.flatValue,
          percentageValue: campaign.percentageValue,
          isApplied: !!isApplied
        };
      });
    }

    loadPinnedCampaings();
    watch(appliedCodes, function () {
      updateCardsList();
    });
    return {
      t: t,
      CouponIcon: CouponIcon,
      openAllCampaignsModal: openAllCampaignsModal,
      cards: cards,
      toggleApplyPromocode: toggleApplyPromocode
    };
  }
});